import device from 'common/support/device';
import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  enableClosedCaptioning,
  disableClosedCaptioning,
  setupClosedCaptioning,
} from 'actions/closedCaptioning';

export const useSystemCC = (platformLibraryLoaded: boolean): void => {
  const dispatch = useDispatch();

  const toggleCC = useCallback(
    (isCCEnabled: boolean) => {
      if (isCCEnabled) {
        dispatch(enableClosedCaptioning());
      } else {
        dispatch(disableClosedCaptioning());
      }
    },
    [dispatch],
  );

  // We want to run this in the beginning so that when app launches or resumes,
  // we get the value of the master CC state from the TV and mirror it to the app.
  useEffect(() => {
    if (
      platformLibraryLoaded &&
      device.useSystemCCSettings &&
      device.isSamsungTizen
    ) {
      if (device.accessibleTextDisplayEnabled()) {
        dispatch(enableClosedCaptioning());
      } else {
        dispatch(disableClosedCaptioning());
      }
    }
  }, [dispatch, platformLibraryLoaded]);

  useEffect(() => {
    if (platformLibraryLoaded) {
      if (device.useSystemCCSettings) {
        if (device.isVizio) {
          device.subscribeToAccessibilityChanges((isCCEnabled: boolean) => {
            toggleCC(isCCEnabled);
          });
        } else if (device.isSamsungTizen) {
          device.subscribeToAccessibilityChanges(() => {
            toggleCC(device.accessibleTextDisplayEnabled());
          });
        } else if (device.isLG_WebOS) {
          device.subscribeToAccessibilityChanges((isCCEnabled: boolean) => {
            toggleCC(isCCEnabled);
          });
        }
      }
    }
  }, [platformLibraryLoaded, toggleCC]);
};

export const useDeviceCC = (): void => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setupClosedCaptioning());
  }, [dispatch]);
};